import React from 'react';


import Spinner from '../compUtils/Spinner'
import MovieThumbInput from './MovieThumbInput'


import ObjectModifiers from './ObjectModifiers';

import MovieThumb from './MovieThumb';


function Movie(props) {


    return (
        <div class="box tile">
            {props.updateConclusion === "UPDATEPENDING" ?
                <Spinner />
                :
                <div class="columns is-mobile">
                    <div class="column is-narrow">
                        <div class="movieThumb">
                            <figure class="image">
                                {props.editState === "READ" ?
                                    props.movie() !== "UNKNOWN" ?
                                    <MovieThumb movieId={props.movieId} imageId={props.movie().thumbnail}/>

                                        :
                                        <Spinner />
                                    :
                                    <MovieThumbInput objectInputState={props.objectInputState} setObjectInputState={props.setObjectInputState}/>
                                }

                            </figure>
                        </div>
                    </div>
                    <div class="column ">

                        <div class="movieTitle">
                            {props.editState === "READ" ?
                                props.movie() !== "UNKNOWN" ?
                                    props.movie().name
                                    :
                                    <Spinner />
                                :
                                <input type="text" defaultValue={props.objectInputState.name} onChange=
                                    {(event) => {
                                        const clone = { ...props.objectInputState }
                                        clone.name = event.target.value
                                        props.setObjectInputState(clone)
                                    }}></input>
                            }
                        </div>

                        <div >
                            {props.editState === "READ" ?
                                props.movie() !== "UNKNOWN" ?
                                    <a href={props.movie().link}>Fiche Allociné</a>
                                    :
                                    <Spinner />
                                :
                                <input type="text" defaultValue={props.objectInputState.link} onChange=
                                    {(event) => {
                                        const clone = { ...props.objectInputState }
                                        clone.link = event.target.value
                                        props.setObjectInputState(clone)
                                    }}></input>
                            }
                        </div>



                    </div>
                    <ObjectModifiers
                        modifiable={props.modifiable}
                        editState={props.editState}
                        updateConclusionState={props.updateConclusionState}
                        startEdit={props.startEdit}
                        startSave={props.startSave}
                        startCancel={props.startCancel}
                    />
                </div>
            }
        </div>


    );
}

export default Movie;